import api from './api'

export default {
  async getShopRankConfig({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getShopRankConfig(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
  async getHomepageRankingList({ commit, state }, params) {
    let res = {}
    try {
      res = await api.getHomepageRankingList(params)
    } catch (error) {
      throw new Error(error.errmsg)
    }
    return res.data
  },
}
